import { __extends } from "tslib";
import { isNull, isUndefined } from '../utils/is';
import { BaseClient } from './client';
var MAX_BATCH_REPORT_LENGTH = 10;
var BATCH_REPORT_WAIT = 1000;
// T: monitor 上报的数据类型, 如 ISendParams
// B: 接口上报的每个 item 的数据类型, 如 BatchEventItem
var BatchClient = /** @class */ (function (_super) {
    __extends(BatchClient, _super);
    function BatchClient(props) {
        var _a, _b;
        var _this = _super.call(this) || this;
        _this.reportQueue = [];
        _this.isReady = true;
        _this.batchReportLength = (_a = props.maxBatchReportLength) !== null && _a !== void 0 ? _a : MAX_BATCH_REPORT_LENGTH;
        _this.batchReportWait = (_b = props.batchReportWait) !== null && _b !== void 0 ? _b : BATCH_REPORT_WAIT;
        _this.batchReportTimeout = null;
        return _this;
    }
    Object.defineProperty(BatchClient.prototype, "ready", {
        /**
         * 上传锁，设置为 false 时所有请求将会被推进列队，等待设置回 true 时一次发出。
         *
         * 默认为 true 不上锁，以保证旧代码不受影响。
         *
         */
        get: function () {
            return this.isReady;
        },
        set: function (v) {
            this.isReady = v;
            if (this.isReady) {
                this._uploadQueue();
            }
        },
        enumerable: false,
        configurable: true
    });
    BatchClient.prototype._send = function (options) {
        var _this = this;
        var params = this.buildParams(options);
        if (isNull(params) || isUndefined(params))
            return;
        this.reportQueue.push(params);
        if (!this.isReady)
            return;
        if (this.reportQueue.length >= this.batchReportLength) {
            this._uploadQueue();
        }
        if (this.batchReportTimeout) {
            clearTimeout(this.batchReportTimeout);
        }
        this.batchReportTimeout = setTimeout(function () {
            _this._uploadQueue();
        }, this.batchReportWait);
    };
    BatchClient.prototype._uploadQueue = function () {
        if (!this.reportQueue.length || !this.ready) {
            return;
        }
        var body = {
            ev_type: 'batch',
            list: this.reportQueue,
        };
        this.reportQueue = [];
        this._request({ event: body, type: 'post' });
    };
    // 需要实现的方法
    BatchClient.prototype._request = function (_options) {
        return;
    };
    return BatchClient;
}(BaseClient));
export { BatchClient };
//# sourceMappingURL=batch.js.map